import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import newsReducer from "../features/news/newsSlice";
import coursesReducer from "../features/courses/coursesSlice";
import documentsReducer from "../features/documents/documentsSlice";
import userReducer from "../features/user/userSlice";
import organisationsReducer from "../features/organisations/organisationsSlice";
import notificationReducer from "../features/notifications/notificationsSlice";
import shiftbatsReducer from "../features/shiftbats/shiftbatsSlice";
import shopReducer from "../features/shop/shopSlice"

const reducersObject = {
    news: newsReducer,
    courses: coursesReducer,
    documents: documentsReducer,
    user: userReducer,
    organisation: organisationsReducer,
    notifications: notificationReducer,
    shiftbats: shiftbatsReducer,
    products: shopReducer
};

const reducers = combineReducers(reducersObject);

const persistConfig = {
    key: "root",
    storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    // reducer: persistedReducer,
    reducer: reducersObject,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);
